<template>
  <div class="q-pa-none">
    <q-header>
      <q-toolbar class="bg-primary text-primary q-my-none header">
        <img src="/images/logo.svg" alt="Logo" class="logo q-pa-xs">
        <q-space/>

        <!-- Desktop Navigation -->
        <nav class="desktop-nav row items-center q-pa-none">
          <template v-for="(item, index) in navigationItems" :key="index">
            <q-btn
                :label="item.label"
                @click="item.action ? item.action() : handleNavigation(item.path)"
                flat
                class="text-no-wrap q-ma-sm"
                :class="{ 'bg-active': isActive(item.path) }"
                v-show="hasAccess(item.roles)"
            />
          </template>

          <!-- User section -->
          <template v-if="user">
            <q-btn flat class="text-no-wrap q-ma-sm" @click="openDialogTokens">
              <q-icon name="o_generating_tokens"/>
              <span class="q-ml-xs">{{ user.tokens }}</span>
            </q-btn>
            <span class="gt-xs text-no-wrap user-info">
              {{ user.name }}
              <q-icon
                  name="logout"
                  @click="handleNavigation('/login')"
                  class="cursor-pointer q-mx-sm"
              />
            </span>
          </template>
        </nav>

        <!-- Mobile menu button -->
        <q-btn
            flat
            round
            dense
            icon="menu"
            class="mobile-menu-btn"
            @click="leftDrawerOpen = !leftDrawerOpen"
        />
      </q-toolbar>
    </q-header>

    <!-- Mobile drawer -->
    <q-drawer
        v-model="leftDrawerOpen"
        :width="200"
        overlay
        bordered
        class="bg-grey-3"
    >
      <q-scroll-area class="fit">
        <div v-if="user" class="text-center q-pa-md">
          <div class="text-weight-bold">{{ user.name }}</div>
          <div class="q-mt-sm cursor-pointer" @click="handleNavigation('/tokens')">
            <q-icon name="o_generating_tokens" size="sm"/>
            <span class="q-ml-xs">{{ user.tokens }}</span>
          </div>
        </div>
        <q-separator/>
        <q-list padding>
          <template v-for="(item, index) in navigationItems" :key="index">
            <q-item
                v-if="hasAccess(item.roles)"
                clickable
                v-ripple
                @click="() => {
                item.action ? item.action() : handleNavigation(item.path);
                leftDrawerOpen = false;
              }"
            >
              <q-item-section>{{ item.label }}</q-item-section>
            </q-item>
          </template>
          <q-separator/>
          <q-item clickable v-ripple @click="handleNavigation('/login')">
            <q-item-section>Выход</q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-drawer>
  </div>

  <!-- NCHZ Dialog -->
  <q-dialog v-model="showDialogNchz">
    <q-card class="nchz-dialog-card">
      <q-card-section class="q-pa-none">
        <a
            :href="botUrl"
            target="_blank"
            @click="sendNchzKeyboard"
        >
          <q-img
              src="/images/nchz.png"
              alt="Готовый список НЧЗ"
              style="max-width: 100%"
          />
        </a>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { ref, computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useTelegram } from '@/utils/useTelegram'
import { navigationConfig } from '@/config/navigation-config' // Импортируем конфигурацию

// Store and router setup
const store = useStore()
const router = useRouter()
const route = useRoute()
const botUrl = inject('BOT_URL')
const { sendNchzKeyboard } = useTelegram()

// Reactive state
const leftDrawerOpen = ref(false)
const showDialogNchz = ref(false)

// Computed properties
const user = computed(() => store.state.user)
const userRole = computed(() => user.value?.role)

// Навигационные элементы с локальной обработкой действия для "Готовые НЧЗ" и проверкой видимости
const navigationItems = computed(() => {
  return navigationConfig
      .filter(item => item.visible !== false) // Фильтруем элементы, где visible не false
      .map(item => {
        if (item.name === 'nchz') {
          return { ...item, action: () => { showDialogNchz.value = true } }
        }
        return item
      })
})

// Methods
const isActive = (path) => route.path === path

const hasAccess = (roles) => {
  // Если роли не указаны или массив пустой, пункт доступен всем
  if (!roles || roles.length === 0) return true
  // Проверяем, есть ли роль пользователя в массиве ролей пункта
  return userRole.value && roles.includes(userRole.value)
}

const handleNavigation = (path) => {
  if (path) {
    router.push(path)
    leftDrawerOpen.value = false
  }
}

const openDialogTokens = () => {
  router.push('/tokens')
}
</script>

<style scoped lang="scss">
.logo {
  height: 50px;
}

.nchz-dialog-card {
  width: 800px;
  max-width: 800px;
  border-radius: 8px;
}

.desktop-nav {
  @media (max-width: 900px) {
    display: none !important;
  }
}

.mobile-menu-btn {
  display: none;
  @media (max-width: 900px) {
    display: block;
  }
}

/* Скрываем кнопку меню на десктопе */
.xs {
  @media (min-width: 901px) {
    display: none;
  }
}
</style>